export default __webpack_public_path__ + "static/media/icon-company-benefits.57968f0d.svg";